import { StarIcon } from '@chakra-ui/icons';
import {
  Img,
  Text,
  VStack,
  chakra,
  Tabs,
  Box,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  HStack,
  Badge,
  WrapItem,
  Center,
  Image,
  Table,
  Flex,
  Button,
  useDisclosure,
  Avatar,
} from '@chakra-ui/react';
import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Back from '../../../images/back.svg';
import BottomNavBar from '../../BottomNavBar';
import format from 'date-fns/format';
import { ptBR } from 'date-fns/locale';
import DotsLoading from '../../Utils/Components/DotsLoading';
import { api } from 'api/api';
import { FaRegUser } from 'react-icons/fa';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import { AccountContext } from 'components/AccountContext';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function CurriculoMedico() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { medico, pic, avaliacao } = state;
  const { user } = useContext(AccountContext);
  const img = process.env.REACT_APP_URL_FOTO_OPERADOR + '/' + medico.dados.medico + '?' + pic;
  const options = { month: 'short', day: 'numeric' };
  const [exp, setExp] = useState([]);
  const [cv, setCv] = useState([]);
  const [descricao_pessoal, setDescricaoPessoal] = useState([]);
  const [fetchMore, setFetchMore] = useState(false);
  const [avaliacoes, setAvaliacoes] = useState([]);
  const theme = getAppTheme(userIsSubscriber(user));
  const modalOpiniao = useDisclosure();
  const [opiniaoExpandida, setOpiniaoExpandida] = useState({});
  const [hasMore, setHasMore] = useState(true);

  console.log(medico.dados.medico);
  const proximasDatas = [];
  let mesPorExtenso = [];
  useEffect(() => {
    let busyStack = false;
    let page = 1;

    const fetchAvaliacoes = async () => {
      if (!hasMore) return;
      setFetchMore(true);
      const newUrl = `${ENDPOINT}/schedule/getAvaliacoes/${medico.dados.medico}?page=${page}&limit=${10}`;
      try {
        const response = await api(newUrl, {
          headers: { 'Content-Type': 'application/json' },
          method: 'GET',
        });
        const data = await response.json();
        if (data.length > 0) {
          setAvaliacoes((prev) => {
            const idsExistentes = new Set(prev.map((a) => a.avaliacao_cliente_id));
            const novasAvaliacoes = data.filter((a) => !idsExistentes.has(a.avaliacao_cliente_id));
            return [...prev, ...novasAvaliacoes];
          });
          page++;
        }
        setHasMore(false);
        setFetchMore(false);
      } catch (error) {
        console.error('Erro ao buscar avaliações:', error);
        setFetchMore(false);
      } finally {
        busyStack = false;
      }
    };

    const handleScroll = async () => {
      if (window.innerHeight + window.scrollY + 5 > document.body.offsetHeight && !busyStack && hasMore) {
        busyStack = true;
        await fetchAvaliacoes();
      }
    };

    fetchAvaliacoes();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [medico.dados.medico]);

  const url = `${ENDPOINT}/schedule/cv/${medico.dados.medico}`;
  async function fetchData(url) {
    try {
      let response = await api(url, {
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
      });
      let data = await response.json();
      setExp(data.experiencia);
      setCv(data.formacao);
      setDescricaoPessoal(data.descricaoPessoal);
      return data;
    } catch (error) {
      console.log(error);

      return [];
    }
  }
  useEffect(() => {
    fetchData(url);
  }, [url]);

  const useEsp = exp.map((item, index) => {
    return (
      <chakra.p color="#616161" p={1} bg="#EEEEEE" fontWeight={'bold'} borderRadius="lg">
        {item.experiencia}
      </chakra.p>
    );
  });

  const useExp = exp.map((item, index) => {
    return (
      <chakra.p color="#616161" p={1} bg="#EEEEEE" fontWeight={'bold'} borderRadius="lg">
        {item.tempo_experiencia}
      </chakra.p>
    );
  });

  const Formacoes = cv.map((item) => (
    <>
      <Table variant="simple" size="lg" minW="100%" id="table-procedures">
        {item.nivel_formacao}
      </Table>
      <chakra.p>{item.formacao_academica + ' - ' + item.data_formacao}</chakra.p>
    </>
  ));

  const toggleExpandir = (index) => {
    setOpiniaoExpandida((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const Dados = avaliacoes ? (
    avaliacoes.map((publico, index) => {
      const arrName = publico.paciente.split(' ');
      const preposicoes = ['das', 'dos', 'des', 'da', 'do', 'de'];
      const nomePaciente = Array.isArray(arrName)
        ? arrName.filter((name, i) => i <= 1 && preposicoes.includes(name.toLowerCase()) === false).join(' ')
        : '';

      const expandido = opiniaoExpandida[index] || false;

      return (
        <Flex key={index} borderRadius="12px" shadow="sm" mt="1em" width="95%" p={4} bg="white" align="flex-start" gap={3}>
          <Box
            minW="50px"
            h="50px"
            borderRadius="full"
            bg="gray.100"
            display="flex"
            alignItems="center"
            justifyContent="center"
            fontSize="1.5em"
            color="gray.500"
          >
            <FaRegUser />
          </Box>

          <Box flex="1">
            <chakra.p fontSize="sm" fontWeight="bold" color="gray.700" textTransform="capitalize">
              {nomePaciente}
            </chakra.p>

            <HStack spacing={1} mt={1} align="center">
              <StarIcon color="#5AB2AE" fontSize="0.9em" />
              <chakra.span fontSize="sm" color="#5AB2AE" fontWeight={600}>
                {publico.avaliacao}
              </chakra.span>
            </HStack>

            <chakra.p mt={2} color="gray.600" fontSize="sm" noOfLines={expandido ? undefined : 2}>
              {publico.opiniao || 'Não deixou comentário'}
            </chakra.p>

            {publico?.opiniao?.length > 50 && (
              <Button variant="link" color="blue.500" mt={1} fontSize="sm" p={0} fontWeight="medium" onClick={() => toggleExpandir(index)}>
                {expandido ? 'Ler menos' : 'Ler mais'}
              </Button>
            )}
          </Box>
        </Flex>
      );
    })
  ) : (
    <Text noOfLines={4} minH={55} color={theme.background} fontWeight="bold" fontSize="0.8em">
      Sem avaliações disponíveis no momento.
    </Text>
  );
  const formatarAvaliacao = (media) => {
    if (isNaN(media)) return '0.0';
    const valor = Math.floor(Number(media) * 10) / 10;
    return valor.toFixed(1);
  };

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';

    const primeiroNome = capitalizar(partes[0]);

    if (partes.length === 1) return primeiroNome;

    const segundoNome = capitalizar(partes[1]);

    return `${primeiroNome} ${segundoNome}`;
  };

  return (
    <>
      <Flex direction="column" minH="100vh" bg="#5AB2AE">
        <Flex align="center" justify="center" h="64px" position="relative" px={4} mt={5}>
          <Img
            src={Back}
            boxSize="36px"
            p={2}
            onClick={() => navigate(-1)}
            position="absolute"
            left="16px"
            cursor="pointer"
            borderRadius="full"
            _hover={{ bg: 'rgba(255,255,255,0.15)' }}
            fallbackSrc={'https://ui-avatars.com/api/?name=' + encodeURIComponent(medico.dados?.nome || medico.dados?.nome || 'Médico')}
          />

          <Text color="white" fontSize="lg" fontWeight="semibold">
            Currículo
          </Text>
        </Flex>

        <Flex justify="center" px={4}>
          <Box w="100%" maxW="420px" bg="#5AB2AE" borderBottomRadius="2xl" pb={6}>
            <Flex justify="center" mt={6}>
              <Avatar
                size="2xl"
                src={medico?.foto || medico?.dados?.foto || img}
                name={tratarNome(medico?.dados?.nome || medico?.nome) || 'Médico'}
                alt={tratarNome(medico?.dados?.nome || medico?.nome)}
                bg="whiteAlpha.300"
                color="white"
                cursor="pointer"
                onClick={() =>
                  navigate('/empresa/medico/curriculo', {
                    state: { medico, avaliacao },
                  })
                }
                borderRadius={'1em'}
              />
            </Flex>

            <Box textAlign="center" mt={4}>
              <Text color="white" fontSize="xl" fontWeight="bold">
                {medico.dados.nome}
              </Text>

              <Flex justify="center" align="center" gap={2} mt={1} wrap="wrap">
                {exp.map((item, index) =>
                  index === 0 ? (
                    <chakra.p color="white" key={index}>
                      {item.experiencia}
                    </chakra.p>
                  ) : null,
                )}

                {!medico.fromExame && (
                  <Text color="white" fontSize="sm">
                    {medico.dados.conselho}
                  </Text>
                )}

                <Text color="white" fontSize="sm">
                  ⭐ {!avaliacao || avaliacao?.avaliacao_media === '0' ? '5.0' : formatarAvaliacao(avaliacao.avaliacao_media)}
                </Text>
              </Flex>
            </Box>
          </Box>
        </Flex>

        <Box bg="white" flex="1" mt="-20px" borderTopRadius="2xl" px={4} pt={6}>
          <Tabs variant="unstyled" h="100%">
            <TabList borderBottom="1px solid" borderColor="gray.200">
              {['Experiência', 'Formação', 'Avaliações'].map((tab) => (
                <Tab
                  key={tab}
                  fontWeight="medium"
                  color="gray.500"
                  _selected={{
                    color: '#5AB2AE',
                    borderBottom: '2px solid',
                    borderColor: '#5AB2AE',
                  }}
                >
                  {tab}
                </Tab>
              ))}
            </TabList>

            <TabPanels mt={4}>
              <TabPanel px={0}>
                <HStack justify="space-between" mb={4}>
                  <VStack align="start">
                    <Text color="gray.500" fontSize="sm">
                      Especialidades
                    </Text>
                    {exp && useEsp}
                  </VStack>

                  <VStack align="start">
                    <Text color="gray.500" fontSize="sm">
                      Experiência
                    </Text>
                    {exp && useExp}
                  </VStack>
                </HStack>

                {!medico?.fromExame && (
                  <>
                    <VStack textAlign={'center'} align="center" mt={4} spacing={2} mb={10}>
                      <Text fontWeight="bold" color="#616161" fontSize="1.2em">
                        Sobre mim
                      </Text>

                      <Text color="#757575" fontSize="1em" textAlign={'center'}>
                        {descricao_pessoal ? descricao_pessoal : medico.dados.descricaoPessoal}
                      </Text>
                    </VStack>
                  </>
                )}
              </TabPanel>

              <TabPanel px={0}>{cv && Formacoes}</TabPanel>

              <TabPanel px={0}>
                {Dados}
                {fetchMore && hasMore && <DotsLoading />}
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Flex>

      <WrapItem mt="35" />
      <BottomNavBar />
    </>
  );
}

export default CurriculoMedico;
